export default __webpack_public_path__ + "static/media/cal.1791254d.svg";